export const PTHRM_LOGO = "/pthrm-mark.png";
export const PTHRM_POSTER = "/pthrm-logo.jpg";

export const PthrmLogo = ({ className = "", testid = "pthrm-logo" }) => (
  <img src={PTHRM_LOGO} alt="PTHRM" className={`select-none object-contain ${className}`} draggable={false} data-testid={testid} />
);
